import React from 'react';
import { observer } from 'mobx-react';
import { isStateTreeNode, getType } from 'mobx-state-tree';
const HeadingComponent = observer(function ({ model, }) {
    if (model === null || model === void 0 ? void 0 : model.target) {
        if (model.target.type) {
            return `${model.target.type} settings`;
        }
        if (isStateTreeNode(model.target)) {
            const type = getType(model.target);
            if (type === null || type === void 0 ? void 0 : type.name) {
                return `${type.name.replace('ConfigurationSchema', '')} settings`;
            }
        }
    }
    return React.createElement(React.Fragment, null, "Settings");
});
export default HeadingComponent;
